class BaseTooltip extends HTMLElement {
  constructor() {
    super();
  }

  get content() {
    return this.getAttribute("content");
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (!this.content) {
      return;
    }

    return window.tippy(this, {
      content: this.content,
      maxWidth: 320
    });
  }
}

if (!customElements.get("base-tooltip")) {
  customElements.define("base-tooltip", BaseTooltip);
}
